import { Field } from "formik";
import { Form } from "react-bootstrap";
import * as Yup from "yup";
// SubForms
import { NameSubForm, Schema as NameSchema } from '../subforms/Name';
import { ContactSubForm, Schema as ContactSchema } from '../subforms/Contact';
import { CitySubForm, Schema as CitySchema } from '../subforms/City';
import { SalaryRequestSubForm, Schema as SalaryRequestSchema } from '../subforms/SalaryRequest';
import { OtherInformationSubForm, Schema as OtherInformationSchema } from '../subforms/OtherInformation';
import { PeriodOfCancelationSubForm, Schema as PeriodOfCancelationSchema } from '../subforms/PeriodOfCancelation';
import { DocumentsStandardSubForm, Schema as DocumentsStandardSchema } from '../subforms/DocumentsStandard';

export const StadtwerkeSpeyerStandardSchema = (settings) => (
    Yup.object()
        .concat(NameSchema(settings))
        .concat(ContactSchema(settings))
        .concat(CitySchema(settings))
        .concat(SalaryRequestSchema(settings))
        .concat(OtherInformationSchema(settings))
        .concat(PeriodOfCancelationSchema(settings))
        .concat(DocumentsStandardSchema(settings))
);

export const StadtwerkeSpeyerStandard = (props) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Text muted>Die im Folgenden mit * markierten Felder sind Pflichtfelder.</Form.Text>
            <Field component={NameSubForm} colors={colors} settings={settings} />
            <Field component={ContactSubForm} colors={colors} settings={settings} />
            <Field component={CitySubForm} colors={colors} settings={settings} />
            <Field component={SalaryRequestSubForm} colors={colors} settings={settings} />
            <Field component={OtherInformationSubForm} colors={colors} settings={settings} />
            <Field component={PeriodOfCancelationSubForm} colors={colors} settings={settings} />
            <Field component={DocumentsStandardSubForm} colors={colors} settings={settings} />
        </>
    );
}